module.exports = __webpack_public_path__ + "img/2.04e38b06.png";